import React, { useEffect } from "react";
import SectionHeading from "../common/SectionHeading";
import { useInView } from "react-intersection-observer";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSection } from "../../reducers/slices/navSlice";
import { Project } from "../../data/Projects";
import { motion } from "framer-motion";
import { fadeIn } from "../../utils/motion";

const ProjectCard = ({ projectCard, index }) => {
  return (
    <motion.div 
      initial="hidden"
      whileInView="show"
      variants={fadeIn("up", "spring", index * 0.1, 1)}
      className="group relative w-full h-[22rem] rounded-2xl overflow-hidden shadow-glass border border-white/10 glass cursor-pointer transition-transform duration-300 hover:-translate-y-2"
    >
      <div className="absolute inset-0 bg-gradient-to-t from-premium-darker via-premium-dark/50 to-transparent opacity-80 z-10 transition-opacity duration-300 group-hover:opacity-90"></div>
      
      <img
        src={projectCard.image}
        alt={projectCard.name}
        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
      />
      
      <div className="absolute bottom-0 left-0 w-full p-6 z-20 flex flex-col justify-end h-full transform translate-y-12 group-hover:translate-y-0 transition-transform duration-500 ease-out">
        <h2 className="text-2xl font-bold text-white mb-2 font-Outfit tracking-tight translate-y-0 group-hover:-translate-y-1 transition-transform duration-300">
          {projectCard.name}
        </h2>
        
        <p className="text-gray-300 text-sm mb-4 line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
          {projectCard.description}
        </p>
        
        <div className="flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-all duration-500 delay-200 transform translate-y-4 group-hover:translate-y-0">
          {projectCard.array.map((icons, i) => (
            <a
              key={i}
              href={icons.link}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-accent-primary hover:border-accent-primary transition-all duration-300"
            >
              {icons.icon}
            </a>
          ))}
        </div>
      </div>
      
      {/* Glow on hover */}
      <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-accent-primary/50 pointer-events-none transition-colors duration-500 z-30"></div>
    </motion.div>
  );
};

const Projects = () => {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const dispatch = useDispatch();
  const { timeOfLastClick } = useSelector((state) => state.activeSec);
  
  useEffect(() => {
    if (inView && Date.now() - timeOfLastClick > 1000) {
      dispatch(setActiveSection("projects"));
    }
  }, [inView]);

  return (
    <section ref={ref} id="projects" className="scroll-mt-20 py-20 relative">
      <SectionHeading text="Featured Projects" />

      <div className="w-[95%] max-w-[1260px] mx-auto relative z-10 mt-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {Project.map((el, index) => (
            <ProjectCard key={index} projectCard={el} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
